import React, { useState } from 'react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useResourceStore } from '../store/resourceStore';
import { ResourceCard } from './ResourceCard';
import { CreateResourceModal } from './CreateResourceModal';
import clsx from 'clsx';

export function Resources() {
  const { 
    setSearchQuery, 
    filteredResources,
    selectedRole,
    selectedSkill,
    setSelectedRole,
    setSelectedSkill
  } = useResourceStore();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const resources = filteredResources();

  const handleRoleClick = (role: 'W2' | '1099') => {
    setSelectedRole(selectedRole === role ? null : role);
  };

  const handleSkillClick = (skill: string) => {
    setSelectedSkill(selectedSkill === skill ? null : skill);
  };

  const handleCreateResource = (data: any) => {
    // TODO: Implement resource creation logic
    console.log('Creating resource:', data);
    setShowCreateModal(false);
  };

  return (
    <div className="space-y-6">
      <div className="bg-gray-800 rounded-lg p-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-white mb-2">Resources</h1>
            <p className="text-gray-400">Manage and view all available consultants</p>
          </div>
          <button
            onClick={() => setShowCreateModal(true)}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
          >
            Create Resource
          </button>
        </div>
      </div>

      <div className="relative">
        <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
        <input
          type="text"
          placeholder="Search by name or skill..."
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full pl-10 pr-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-red-500"
        />
      </div>

      {(selectedRole || selectedSkill) && (
        <div className="flex gap-2">
          {selectedRole && (
            <button
              onClick={() => setSelectedRole(null)}
              className={clsx(
                'px-3 py-1.5 text-sm font-medium rounded-full flex items-center gap-2',
                selectedRole === 'W2' ? 'bg-blue-100 text-blue-800' : 'bg-purple-100 text-purple-800'
              )}
            >
              {selectedRole}
              <XMarkIcon className="h-4 w-4" />
            </button>
          )}
          {selectedSkill && (
            <button
              onClick={() => setSelectedSkill(null)}
              className="px-3 py-1.5 text-sm bg-gray-700 text-gray-300 rounded-full flex items-center gap-2"
            >
              {selectedSkill}
              <XMarkIcon className="h-4 w-4" />
            </button>
          )}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {resources.map((resource) => (
          <ResourceCard
            key={resource.id}
            resource={resource}
            onRoleClick={handleRoleClick}
            onSkillClick={handleSkillClick}
          />
        ))}
      </div>
      
      {showCreateModal && (
        <CreateResourceModal
          onClose={() => setShowCreateModal(false)}
          onSubmit={handleCreateResource}
        />
      )}
    </div>
  );
}